import LoginRequest from "../Requests/Auth/LoginRequest";
import HttpService from "../Services/HttpService";
import User from "../Models/User";
import PersistantStorage from "../PersistantStorage";

export default class AuthRepository
{
  private readonly storage: PersistantStorage<User> = new PersistantStorage<User>("AUTH_USER");
  public user?: User;
  
  public load(): void
  {
    this.user = this.storage.get();
  }

  public async login(request: LoginRequest): Promise<void>
  {
    const url = "/Authentication/Login"
    this.user = await HttpService.post<User>(url, request);
    this.storage.set(this.user);
  }

  public logout(): void
  {
    this.user = undefined;
    this.storage.clear();
  }
}

export const authRepository = new AuthRepository();